import { styled } from '@mui/material';

import Page from '@/components/Page/index.ts';
import { getActiveCompetition, competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import type { Route } from './+types/LandingPage';
import { Footer } from './_sections/Footer.tsx';
import { RulesSection } from './_sections/RulesSection.tsx';
import { StatsSection } from './_sections/StatsSection.tsx';
import { TimerSection } from './_sections/TimerSection.tsx';
import { TopSection } from './_sections/TopSection.tsx';
import { WinnersSection } from './_sections/WinnersSection.tsx';

const Root = styled('div')({
  width: '100%',
  backgroundColor: 'white',
});

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const activeCompetition = await getActiveCompetition(competitions);
  const januaryWinner = competitions.find((c) => c.slug === 'january_open_2025_campaign')
    ?.winners[0];
  const februaryWinners = competitions.find((c) => c.slug === 'february_2025_campaign')?.winners;
  const allWinners = [...competitions].reverse().flatMap((d) => d.winners);
  return { activeCompetition, januaryWinner, februaryWinners, allWinners };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  return (
    <Page title="Gjeldfri februar trekning">
      <Root>
        <TopSection
          activeCompetition={loaderData.activeCompetition}
          januaryWinner={loaderData.januaryWinner}
          februaryWinners={loaderData.februaryWinners}
        />
        <TimerSection activeCompetition={loaderData.activeCompetition} />
        <WinnersSection allWinners={loaderData.allWinners} />
        <RulesSection activeCompetition={loaderData.activeCompetition} />
        <StatsSection activeCompetition={loaderData.activeCompetition} />
        <Footer />
      </Root>
    </Page>
  );
}
